module.exports = __webpack_public_path__ + "static/media/moto-map.deca645a.png";